<script setup>
import ImagePreview from "@/components/ImagePreview/index.vue";

const props = defineProps({
  maxShowCnt: {
    type: Number,
    default: 3
  },
  picList: {
    type: Array,
    default: () => Array.of()
  },
  picUrlKey: {
    type: String,
    default: "tempAccessUrl"
  },
  picKey: {
    type: String,
    default: "fileId"
  },
  imgClass: {
    type: String,
    default: "size-12 rounded-md"
  },
  wrapClass: {
    type: String,
    default: "flex flex-wrap gap-1"
  }
});

const showImgs = computed(() => {
  return props.picList.slice(0, props.maxShowCnt);
});

const dialogTableVisible = ref(null);
</script>

<template>
  <TransitionGroup class="relative" :class="wrapClass" name="list" tag="div">
    <ImagePreview
      v-for="pic in showImgs"
      :key="pic[picKey]"
      :pic-list="picList.map((f) => f[picUrlKey])"
      :src="pic[picUrlKey]"
      :class="imgClass"
      fit="cover"
    />

    <div
      @click="dialogTableVisible = true"
      :class="imgClass"
      v-if="picList.length > maxShowCnt"
      class="flex cursor-pointer items-center justify-center bg-gray-100 transition hover:bg-gray-200"
    >
      <el-icon style="font-size: 16px">
        <MoreFilled />
      </el-icon>
    </div>
  </TransitionGroup>

  <el-drawer append-to-body v-model="dialogTableVisible" title="全部图片" size="800">
    <ImageListPreview
      wrap-class="flex flex-wrap gap-4"
      :max-show-cnt="Infinity"
      :pic-list="picList"
      img-class="size-44"
    />
  </el-drawer>
</template>

<style scoped lang="scss">
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease-out;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: scale3d(0, 0, 0);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>
